import Immutable from 'immutable'

const WordTimeAdjustment = new Immutable.Record({
	defaultValue: 0,
	min: 0,
	max: 0,
});

export default WordTimeAdjustment;
